import { render, staticRenderFns } from "./ComingSoon.vue?vue&type=template&id=5c12bb92&"
import script from "./ComingSoon.ts?vue&type=script&lang=ts&"
export * from "./ComingSoon.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports